export enum Coupons {
    take90 = 'take90',
    welcome20 = 'welcome20',
    welcome50 = 'welcome50',
    getbalance = 'getbalance',
    annual30 = 'annual30',
    joinhb = 'joinhb',
    pictime = 'pictime',
    cyber23 = 'cyber23',
    hb2024save = 'hb2024save',
    urgent = 'start50',
    save50 = 'save50',
    join50 = 'join50',
    join30 = 'join30',
    freelancersunion = 'freelancersunion',
    adobe50 = 'adobe50',
    zoom60 = 'zoom60',
    levelup30 = 'levelup30',
    grow30 = 'grow30',
    prismm = 'prismm50',
    cyber24 = 'cyber24',
    theknot = 'theknot',
    wmba24 = 'wmba24',
    jan25 = 'jan25',
    off25 = 'off25',
    showit2025 = 'showit2025',
    priceupdate20 = 'priceupdate20',
    beccaluna = 'beccaluna',
    wppi30 = 'wppi30',
    imagen30 = 'imagen30',
    blazeai30 = 'blazeai30',
    rella30 = 'rella30',
    timelinegenius = 'hbtg',
    timelinegenius1yf = 'hbtg1yf',
    // test coupons
    test_flexible_coupon = 'test_flexible_coupon',
    test_flexible_monthly_only = 'test_flexible_monthly_only',
    test_regular_coupon = 'test_regular_coupon',
    test_referral_coupon = 'test_referral_coupon',
    test_expired_coupon = 'test_expired_coupon',
    weven = 'weven'
}

export const CURRENT_PROMO_COUPON_CODE = '';
export const UPCOMING_PROMO_COUPON_CODE = '';

export const OLD_PROMOS_COUPON_CODES = [
    Coupons.joinhb,
    Coupons.welcome20,
    'only1',
    'onlyone',
    Coupons.take90,
    Coupons.annual30,
    Coupons.cyber23,
    Coupons.welcome50,
    Coupons.hb2024save,
    Coupons.urgent,
    Coupons.save50,
    Coupons.join50,
    Coupons.join30,
    Coupons.cyber24
];

// These flexible coupons have been wrongly configured (the parent coupon is the same as the children ones)
// We still want to fetch the details from the server for the following coupons
// TO Remove once these coupons are expired
export const FORCE_FETCH_DETAILS_COUPONS_LIST = [
    'annual30',
    'take90',
    'pictime'
];

// Use this mapping when changing the promo code without creating a new coupon in Recurly
export const alternativeCouponMapping = {
    [Coupons.off25]: Coupons.jan25
};
